export enum Status {
  Success = "success",
  Error = "error",
  AuthError = "auth_error",
}
